<template>
  <div class="liveRoom">
    <el-container>
      <!-- <el-aside
        width="200px"
        style="height: 800px;padding-right:10px;overflow: auto"
      >
        <el-tree
          :data="treeData"
          :props="defaultProps"
          highlight-current
          :accordion="true"
          :expand-on-click-node="false"
          :filter-node-method="nodeFilter"
          @node-click="handleNodeClick"
          default-expand-all
          v-loading="treeLoading"
          ref="tree"
        ></el-tree>
      </el-aside> -->

      <el-main style="padding: 2px;">
        <!-- <el-card>
          <el-form ref="searchForm" :model="searchForm" :label-width="searchFormLabelWidth">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label prop="name">
                  <el-input
                    style="width: 100%;"
                    :size="componentSize"
                    v-model="searchForm.name"
                    placeholder="请输入直播间名称"
                    auto-complete="off"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button
                  :size="componentSize"
                  type="primary"
                  @click="pageList"
                  icon="el-icon-search"
                >搜索</el-button>
                <el-button
                  :size="componentSize"
                  type="primary"
                  @click="reset"
                  icon="el-icon-refresh"
                >重置</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>-->

        <el-card>
          <el-row :gutter="20">
            <el-col :sm="24" :md="12" :lg="4">
              <el-cascader
                style="width:100%"
                clearable
                collapse-tags
                v-model="courseIds"
                :show-all-levels="false"
                :props="subjectTreeProp"
                placeholder="请输入所属科目"
                :options="subjectTreeList"
                @change="subjectChangeTop"
              ></el-cascader>
          </el-col>
            <el-col :span="4">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                v-model="searchForm.courseName"
                placeholder="请输入直播名称"
                auto-complete="off"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="4">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                v-model="searchForm.teacherName"
                placeholder="请输入老师名称"
                auto-complete="off"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="6" style="float:right">
              <el-button
                :size="componentSize"
                type="primary"
                @click="page.pageNumber=1,pageList()"
                icon="el-icon-search"
                style="float:right"
              >查询</el-button>
              <!-- <el-button
                  :size="componentSize"
                  type="primary"
                  @click="reset"
                  icon="el-icon-refresh"
              >重置</el-button>-->
            </el-col>
          </el-row>
        </el-card>
        <el-card class="box-card">
          <el-row :span="24">
            <el-col :span="12">
              <el-button
                :size="componentSize"
                type="primary"
                @click="addFormVisible = true"
                icon="el-icon-plus"
              >添加</el-button>
              <!-- <el-button
                :size="componentSize"
                type="danger"
                @click="batchDeleteLiveRoom"
                icon="el-icon-minus"
                v-if="permissions.indexOf('/liveRoom/deleteLiveRoom') > -1"
              >批量删除</el-button>-->
            </el-col>
            <!-- <el-col style="text-align: right" :span="12">
              <el-button
                :size="componentSize"
                type="primary"
                @click="importFormVisible = true"
                icon="el-icon-download"
                v-if="permissions.indexOf('/liveRoom/import') > -1"
              >导入</el-button>
              <el-button
                :size="componentSize"
                style="text-align: right"
                type="primary"
                @click="exportExcel"
                :loading="loading"
                icon="el-icon-upload2"
                v-if="permissions.indexOf('/liveRoom/export') > -1"
              >导出</el-button>
            </el-col>-->
          </el-row>
          <el-table
            :size="componentSize"
            ref="multipleTable"
            :data="page.rows"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 100%;"
            border
            v-loading="tableLoading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.8)"
            @selection-change="selectionChange"
          >
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <el-table-column prop="subjectCourseName" label="科目课程"></el-table-column>
            <el-table-column prop="name" label="直播名称"></el-table-column>
            <el-table-column prop="teacherName" label="主讲老师"></el-table-column>
            <el-table-column prop="courseCount" label="课时数"></el-table-column>
            <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type==1">线上课</span>
                <span v-if="scope.row.type==2">公开课</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop label="启用/禁用" width="120">
              <template slot-scope="scope">
                <el-switch
                  class="switch-style"
                  :size="componentSize"
                  @change="active(scope.row)"
                  :active-value="1"
                  :inactive-value="-1"
                  active-text="启"
                  inactive-text="禁"
                  v-model="scope.row.active"
                  active-color="#409EFF"
                  inactive-color="#D2D2D2"
                ></el-switch>
              </template>
            </el-table-column>-->
            <el-table-column prop label="操作" width="200" align="center">
              <template slot-scope="scope" class="liveRoom-rate">
                <div class="operationGroup">
                  <span
                  class="operation-style"
                    type="text"
                    @click="selection = scope.row.id, editFormVisible = true"
                  >编辑</span>
                  <span type="text" class="operation-style" @click="goLiveInfo(scope.row)">排课</span>
                  <el-popover placement="top" width="180" trigger="hover">
                    <div v-for="(item,index) in scope.row.liveEvaluationList" :key="index">
                      <div v-if="item.type==1" style="display:flex">
                        <!-- <span>1.授课生动有趣易理解：</span> -->
                        <span>评分：</span>
                        <el-rate
                          v-model="item.average"
                          disabled
                          show-score
                          text-color="#ff9900"
                          score-template="{value}"
                        ></el-rate>
                      </div>
                      <!-- <div v-if="item.type==2" style="display:flex">
                        <span>2.内容阐述清晰，重点突出：</span>
                        <el-rate
                          v-model="item.average"
                          disabled
                          show-score
                          text-color="#ff9900"
                          score-template="{value}"
                        ></el-rate>
                      </div>
                      <div v-if="item.type==3" style="display:flex">
                        <span>3.逻辑清晰，内容连贯，节奏适中：</span>
                        <el-rate
                          v-model="item.average"
                          disabled
                          show-score
                          text-color="#ff9900"
                          score-template="{value}"
                        ></el-rate>
                      </div> -->
                    </div>
                    <span class="operation-style" slot="reference" type="text">学员评价</span>
                  </el-popover>
                  <el-dropdown>
                    <span class="operation-style" type="text">更多</span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="getViewerStatistics(scope.row)">观看人数统计</el-dropdown-item>
                      <el-dropdown-item @click.native="deleteLiveRoom(scope.row)">删除课程</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <el-button type="text" @click="deleteLiveRoom(scope.row)">删除</el-button> -->
                  <!-- <span style="width:25%" @click="getInfoById(scope.row.id)">
                  <i class="iconfont iconchakan1 mainColor" title="查看"></i>-->
                  <!-- <span
                    @click="selection = scope.row.id, detailFormVisible = true"
                  >
                    <i class="el-icon-view" title="查看"></i>
                  </span>
                  <span
                    @click="selection = scope.row.id, editFormVisible = true"
                  >
                    <i class="el-icon-edit" title="编辑"></i>
                  </span>
                  <span
                    @click="deleteLiveRoom(scope.row)"
                  >
                    <i class="el-icon-delete" title="删除"></i>
                  </span>-->
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            style="margin-top: 20px;text-align: right;"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-card>
      </el-main>
    </el-container>

    <el-dialog title="添加直播课程" :visible.sync="addFormVisible" width="800px" left :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="直播名称" prop="name">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                v-model="addForm.name"
                placeholder="请输入直播名称"
                auto-complete="off"
                maxlength="19"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属科目" prop="courseId">
              <el-cascader
                style="width:100%"
                clearable
                v-model="addForm.courseId"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请选择所属科目"
                :options="subjectTreeList"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属校区" prop="campusId">
              <el-cascader
                style="width:100%"
                clearable
                v-model="addForm.campusId"
                :show-all-levels="false"
                :props="campusListProps"
                placeholder="请选择所属校区"
                :options="campusList"
                @change="getTeacherList(addForm.campusId[2])"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="主讲老师" prop="teacherId">
              <el-select placeholder="请选择主讲老师" style="width:100%" v-model="addForm.teacherId">
                <el-option
                  v-for="item in teacherList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="直播类型" prop="courseId">
              <el-radio v-model="addForm.type" label="1">线上课</el-radio>
              <el-radio v-model="addForm.type" label="2">公开课</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="addForm.type == '2'">
            <el-form-item label="课程简介" prop="summary">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                v-model="addForm.summary"
                placeholder="请输入课程简介"
                auto-complete="off"
                maxlength="19"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="addForm.type == '2'">
            <el-form-item label="课程封面" prop="cover">
              <el-upload
                :action="fileAction"
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="addForm.cover" :src="addForm.cover" class="avatar" />
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                style="width: 100%;"
                :size="componentSize"
                v-model="addForm.remark"
                placeholder="请输入备注"
                auto-complete="off"
                maxlength="255"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="addLiveRoom">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="detailFormVisible"
      :width="detailFormDialogWidth"
      left
      v-if="permissions.indexOf('/liveRoom/getLiveRoom') > -1"
    >
      <el-form
        class="detail-form-dialog"
        ref="detailForm"
        :model="detailForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="科目课程id" prop="courseId">{{detailForm.courseId}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="老师id" prop="teacherId">{{detailForm.teacherId}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="直播间名称" prop="name">{{detailForm.name}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">{{detailForm.remark}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      :width="editFormDialogWidth"
      left
      v-if="permissions.indexOf('/liveRoom/updateLiveRoom') > -1"
    >-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" width="800px" left :close-on-click-modal="false">
      <el-form
        class="edit-form-dialog"
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="直播名称" prop="name">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                v-model="editForm.name"
                placeholder="请输入直播名称"
                auto-complete="off"
                maxlength="19"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属科目" prop="courseId">
              <el-cascader
                style="width:100%"
                clearable
                v-model="editForm.courseId"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请选择所属科目"
                :options="subjectTreeList"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属校区" prop="campusId">
              <el-cascader
                style="width:100%"
                clearable
                v-model="editForm.campusId"
                :show-all-levels="false"
                :props="campusListProps"
                placeholder="请选择所属校区"
                :options="campusList"
                @change="getTeacherList(editForm.campusId[2])"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="主讲老师" prop="teacherId">
              <el-select placeholder="请选择主讲老师" style="width:100%" v-model="editForm.teacherId">
                <el-option
                  v-for="item in teacherList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="直播类型" prop="courseId">
              <el-radio v-model="editForm.type" label="1">线上课</el-radio>
              <el-radio v-model="editForm.type" label="2">公开课</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="editForm.type==2">
            <el-form-item label="课程简介" prop="summary">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                v-model="editForm.summary"
                placeholder="请输入课程简介"
                auto-complete="off"
                maxlength="19"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="editForm.type==2">
          <el-col :span="12">
            <el-form-item label="课程封面" prop="cover">
              <el-upload
                :action="fileAction"
                list-type="picture-card"
                :show-file-list="false"
                :on-success="editHandleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="editForm.cover" :src="editForm.cover" class="avatar" />
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              style="width: 100%;"
              :size="componentSize"
              v-model="editForm.remark"
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="255"
              clearable
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="editFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="updateLiveRoom">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="导入"
      :visible.sync="importFormVisible"
      width="80%"
      left
      v-if="permissions.indexOf('/liveRoom/import') > -1"
    >
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="componentSize" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        :size="componentSize"
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="courseId" label="科目课程id"></el-table-column>
        <el-table-column prop="teacherId" label="老师id"></el-table-column>
        <el-table-column prop="name" label="直播间名称"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="componentSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
        >导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      treeLoading: false,
      tableLoading: false,
      blockTreeAdd: false,
      blockTreeEdit: false,
      blockTreeDelete: false,
      blockAddLiveRoom: false,
      blockEditLiveRoom: false,
      blockDeleteLiveRoom: false,
      blockBatchDeleteLiveRoom: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      componentSize: "",
      rateList: [],
      addFormDialogWidth: "",
      detailFormDialogWidth: "",
      editFormDialogWidth: "",
      addFormVisible: false,
      detailFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      campusListProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      subjectTreeList: [],
      campusList: [],
      teacherList: [],
      searchForm: {
        name: null,
        courseIds: []
      },
      addForm: {
        type: "1",
        summary: "",
        cover: null,
        courseId: null,
        teacherId: null,
        remark: null
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入直播名称",
            trigger: "blur"
          }
        ],
        campusId: [
          {
            required: true,
            message: "请选择所属校区",
            trigger: "change"
          }
        ],
        courseId: [
          {
            required: true,
            message: "请输入科目课程",
            trigger: "change"
          }
        ],
        summary: [
          {
            required: true,
            message: "请输入课程简介",
            trigger: "change"
          }
        ],
        cover: [
          {
            required: true,
            message: "请上传课程封面",
            trigger: "change"
          }
        ],
        teacherId: [
          {
            required: true,
            message: "请输入老师id",
            trigger: "blur"
          }
        ]
      },
      detailForm: {
        id: null,
        courseId: null,
        teacherId: null,
        name: null,
        remark: null
      },
      editForm: {
        type: "1",
        summary: "",
        cover: null,
        courseId: null,
        teacherId: null,
        remark: null
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入直播名称",
            trigger: "blur"
          }
        ],
        campusId: [
          {
            required: true,
            message: "请选择所属校区",
            trigger: "change"
          }
        ],
        courseId: [
          {
            required: true,
            message: "请输入科目课程",
            trigger: "change"
          }
        ],
        summary: [
          {
            required: true,
            message: "请输入课程简介",
            trigger: "change"
          }
        ],
        cover: [
          {
            required: true,
            message: "请上传课程封面",
            trigger: "change"
          }
        ],
        teacherId: [
          {
            required: true,
            message: "请输入老师id",
            trigger: "blur"
          }
        ]
      },
      importForm: {},
      searchFormLabelWidth: "0px",
      formLabelWidth: "80px",
      treeSelection: "",
      selection: "",
      multipleSelection: "",
      ids: [],
      rangePickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/liveRoom/upload`,
      fileList: [],
      loading: false,
      permissions: [],
      filter: "",
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },
  computed: {
    
    upLoadData() {
      return {
        openId: this.$store.state.loginData.openId,
        token: this.$store.state.loginData.token,
        LoginType: "agent"
      };
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.addForm.cover = res.data;
    },
    editHandleAvatarSuccess(res, file) {
      this.editForm.cover = res.data;
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return  isLt2M;
    },
    setComponentSize() {
      // if (document.body.clientWidth <= 992) {
      //   this.componentSize = "medium";
      //   return;
      // }
      // if (document.body.clientWidth <= 1200) {
      //   this.componentSize = "medium";
      //   return;
      // }
      // if (document.body.clientWidth <= 1920) {
      //   this.componentSize = "medium";
      //   return;
      // }
    },
    setDialogWidth() {
      if (document.body.clientWidth > 1366) {
        this.addFormDialogWidth = "30%";
      } else {
        this.addFormDialogWidth = "40%";
      }
      if (document.body.clientWidth > 1366) {
        this.detailFormDialogWidth = "40%";
      } else {
        this.detailFormDialogWidth = "50%";
      }
      if (document.body.clientWidth > 1366) {
        this.editFormDialogWidth = "30%";
      } else {
        this.editFormDialogWidth = "40%";
      }
      if (document.body.clientWidth > 1366) {
        this.treeAddFormDialogWidth = "30%";
      } else {
        this.treeAddFormDialogWidth = "40%";
      }
      if (document.body.clientWidth > 1366) {
        this.treeEditFormDialogWidth = "30%";
      } else {
        this.treeEditFormDialogWidth = "40%";
      }
    },
    handleCommand(command) {
      if (command == "a") {
        this.$router.push("/liveData");
      }
      if (command != "a") {
        this.deleteLiveRoom(command);
      }
    },
    goLiveInfo(row) {
      localStorage.setItem("jump", JSON.stringify({ id: row.id }));
      this.$router.push({ path: "/liveInfo", query: { id: row.id } });
    },
    getCampusList() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取老师列表
    getTeacherList(id) {
      this.api.agentUserInfo.getTeacherList({ campusId: id }).then(result => {
        if (result.success) {
          this.teacherList = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getLiveRoomDetail() {
      this.api.liveRoom
        .getLiveRoomDetail({
          id: this.selection
        })
        .then(result => {
          if (result.success) {
            this.detailForm = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getLiveRoom() {
      this.api.liveRoom
        .getLiveRoom({
          id: this.selection
        })
        .then(result => {
          if (result.success) {
            this.editForm = result.data;
            this.editForm.type = String(this.editForm.type);
            this.getCampusList();
            this.getTeacherList(this.editForm.campusId);
            this.getSubjectTreeList();
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // queryPageList() {
    //   this.tableLoading = true;
    //   this.searchForm.pageSize = this.page.pageSize;
    //   this.searchForm.pageNumber = 1;
    //   this.searchForm.sortName = this.page.sortName;
    //   this.searchForm.sortOrder = this.page.sortOrder;
    //   this.api.liveRoom
    //     .pageList(this.searchForm)
    //     .then(result => {
    //       this.page.rows = result.data.records;
    //       this.page.total = result.data.total;
    //       this.tableLoading = false;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    subjectChangeTop() {
      this.searchForm.courseIds = [];
      this.courseIds.forEach(e=>{
        this.searchForm.courseIds.push(e[2]);
      })
      // this.searchForm.courseIds = this.courseIds;
      // console.log("11",this.searchForm.courseIds)
    },
    pageList() {
      this.tableLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.liveRoom
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.tableLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addLiveRoom() {
      if (this.blockAddLiveRoom) {
        return false;
      }
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.addForm.type == 1) {
            this.addForm.summary = "";
            this.addForm.cover = "";
          }
          this.blockAddLiveRoom = true;
          if (typeof this.addForm.campusId == "object") {
            this.addForm.campusId = this.addForm.campusId[2];
          }
          if (typeof this.addForm.courseId == "object") {
            this.addForm.courseId = this.addForm.courseId[2];
          }
          this.api.liveRoom
            .addLiveRoom(this.addForm)
            .then(result => {
              this.blockAddLiveRoom = false;
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
                this.blockAddLiveRoom = false;
              }
            })
            .catch(error => {
              this.blockAddLiveRoom = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateLiveRoom() {
      if (this.blockEditLiveRoom) {
        return false;
      }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (this.editForm.type == 1) {
            this.editForm.summary = "";
            this.editForm.cover = "";
          }
          if (typeof this.editForm.campusId == "object") {
            this.editForm.campusId = this.editForm.campusId[2];
          }
          if (typeof this.editForm.courseId == "object") {
            this.editForm.courseId = this.editForm.courseId[2];
          }
          this.blockEditLiveRoom = true;
          this.api.liveRoom
            .updateLiveRoom(this.editForm)
            .then(result => {
              this.blockEditLiveRoom = false;
              if (result.success) {
                this.$message.success(result.message);
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
                this.blockEditLiveRoom = false;
              }
            })
            .catch(error => {
              this.blockEditLiveRoom = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    getViewerStatistics(row){
      this.$router.push({path:'/liveData',query:{id:row.id}})
    },
    deleteLiveRoom(row) {
      console.log("11111");
      if (this.blockDeleteLiveRoom) {
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockDeleteLiveRoom = true;
          this.api.liveRoom
            .deleteLiveRoom([
              {
                id: row.id
              }
            ])
            .then(result => {
              this.blockDeleteLiveRoom = false;
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              this.blockDeleteLiveRoom = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteLiveRoom() {
      if (this.blockBatchDeleteLiveRoom) {
        return false;
      }
      if (this.ids.length === 0) {
        this.$message.error("请选择要删除的数据！");
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockBatchDeleteLiveRoom = true;
          this.api.liveRoom
            .deleteLiveRoom(this.ids)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockBatchDeleteLiveRoom = false;
            })
            .catch(error => {
              this.blockBatchDeleteLiveRoom = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.liveRoom
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.liveRoom
        .importData(this.importForm.rows)
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.importFormVisible = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTree() {
      this.treeLoading = true;
      this.api.liveRoom
        .getTree({})
        .then(result => {
          if (result.success) {
            this.treeData = result.data;
            if (this.treeData !== null && this.treeData.length > 0) {
              this.pageList();
            }
            this.treeLoading = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleNodeClick(data) {
      if (!data.disabled) {
        this.pageList();
      }
    },
    active(row) {
      this.api.liveRoom
        .active(row)
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
          this.pageList();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getPermissionList() {
      let user = JSON.parse(localStorage.user);
      user.resources.forEach(e => {
        e.resources.forEach(a => {
          a.resources.forEach(x => this.permissions.push(x.url));
        });
      });
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
      } else {
        this.getCampusList();
        this.getSubjectTreeList();
      }
    },
    detailFormVisible: function(newVal) {
      if (newVal) {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".detail-form-dialog")
        });
        this.getLiveRoomDetail();
        loading.close();
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.editForm.campusId = null;
        this.editForm.courseId = null;
        this.editForm.cover = "";
        this.editForm.id = "";
        this.editForm.name = "";
        this.editForm.summary = "";
        this.editForm.teacherId = "";
        this.editForm.type = "";
        // this.$refs.editForm.resetFields();
        // this.pageList();
      } else {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".edit-form-dialog")
        });
        this.getLiveRoom();
        loading.close();
      }
    }
  },
  mounted() {
    this.setComponentSize();
    this.setDialogWidth();
    this.getPermissionList();
    // this.getTree();
    this.pageList();
    this.getSubjectTreeList();
  }
};
</script>
<style lang="less" rel="stylesheet/less">
.liveRoom {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 148px;
    display: block;
  }
  .liveRoom-rate{
    .el-rate{
      line-height:20px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/liveRoom/index.vue